import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import updateSwiperControlsVisibility from './swiper-controls.js';

export default {
	init() {
		const selector = '.layout.testimonials .cards-swiper';
		const sliders = document.querySelectorAll(selector);
		if (!sliders.length) return;

		function initOne(sliderEl) {
			const sectionEl = sliderEl.closest('.cards-section') || sliderEl.parentElement;
			const paginationEl = sectionEl ? sectionEl.querySelector('.swiper-pagination') : null;
			const nextEl = sectionEl ? sectionEl.querySelector('.swiper-button-next') : null;
			const prevEl = sectionEl ? sectionEl.querySelector('.swiper-button-prev') : null;

			const pagination = paginationEl ? { el: paginationEl, clickable: true } : undefined;
			const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

			if (sliderEl._testimonialsSwiper) {
				try {
					sliderEl._testimonialsSwiper.destroy(true, true);
				} catch (e) {
					// no-op
				}
				sliderEl._testimonialsSwiper = undefined;
			}

			const swiper = new Swiper(sliderEl, {
				modules: [Navigation, Pagination],
				slidesPerView: 2,
				spaceBetween: 20,
				grabCursor: true,
				watchOverflow: true,
				observer: true,
				observeParents: true,
				pagination,
				navigation,
				breakpoints: {
					0: { slidesPerView: 1 },
					769: { slidesPerView: 2 },
				},
			});

			updateSwiperControlsVisibility(swiper, {
				sliderEl,
				sectionEl,
				paginationEl,
				nextEl,
				prevEl,
			});
			swiper.on('resize', () =>
				updateSwiperControlsVisibility(swiper, {
					sliderEl,
					sectionEl,
					paginationEl,
					nextEl,
					prevEl,
				})
			);
			swiper.on('breakpoint', () =>
				updateSwiperControlsVisibility(swiper, {
					sliderEl,
					sectionEl,
					paginationEl,
					nextEl,
					prevEl,
				})
			);

			sliderEl._testimonialsSwiper = swiper;
		}

		sliders.forEach((sliderEl) => initOne(sliderEl));
	},
};
